export const detailCardSx = {
  p: 3,
  backgroundColor: "#fcfcfc",
  borderRadius: "12px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  position: "relative",
  mt: 0.5,
  mb: 3,
};

export const detailsGridSx = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 280px), 1fr))",
  gridAutoRows: "minmax(48px, auto)",
  gap: 0.75,
};

export const detailItemSx = {
  backgroundColor: "#fff",
  px: 1.25,
  py: 1,
  borderRadius: "6px",
  borderLeft: "4px solid #3498db",
  display: "flex",
  alignItems: "center",
  fontSize: "0.9rem",
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
  gap: 0.5,
};
